module.exports = __webpack_public_path__ + "img/在线咨询.svg";